import React from 'react';
import { TaskAlt } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import clsx from 'clsx';
import { ReactComponent as CalendarIcon } from '../../../assets/chat/calendar_blank.svg';
import { ReactComponent as CheckedIcon } from '../../../assets/common/checked.svg';
import './AssistantChatSuggestedBlockCTA.scss';
import { useTranslation } from 'react-i18next';

interface AssistantChatSuggestedBlockCTAProps {
  title?: string;
  type?: 'calendar' | 'task';
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  processed?: boolean;
}

const AssistantChatSuggestedBlockCTA: React.FC<AssistantChatSuggestedBlockCTAProps> = ({
  title,
  type = 'calendar',
  onClick,
  loading = false,
  disabled = false,
  processed = false,
}) => {
  const { t } = useTranslation();
  const isDisabled = disabled || loading || processed;
  const displayTitle = processed
    ? t('task.ai.suggestedBlocks.done')
    : (title ?? t('task.ai.suggestedBlocks.checkOnCalendar'));
  const startIcon = loading ? undefined : processed ? (
    <CheckedIcon className="assistant-chat-suggested-block-item__check-icon" />
  ) : type === 'calendar' ? (
    <CalendarIcon />
  ) : (
    <TaskAlt />
  );

  return (
    <div className="assistant-chat-suggested-block-item__container">
      <LoadingButton
        className={clsx('assistant-chat-suggested-block-item', {
          'assistant-chat-suggested-block-item--disabled': isDisabled,
        })}
        onClick={() => !isDisabled && onClick()}
        disabled={isDisabled}
        loading={loading}
        startIcon={startIcon}
      >
        {displayTitle}
      </LoadingButton>
    </div>
  );
};

export default AssistantChatSuggestedBlockCTA;
